import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface SettingsRowProps {
  label: string;
  hint?: string;
  /** Right-aligned control (toggle, select, button, etc.). */
  control: ReactNode;
}

// One row inside a <SettingsCard>: label + optional hint on the leading side, control on
// the trailing side, with a hairline divider that suppresses on the last child.
export function SettingsRow({ label, hint, control }: SettingsRowProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        py: 2,
        gap: 2,
        borderBottom: 1,
        borderBottomColor: 'divider',
        '&:last-child': { borderBottom: 0 },
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 500, color: 'text.primary' }}>
          {label}
        </Typography>
        {hint && (
          <Typography
            sx={{ fontSize: 12.5, color: 'text.secondary', mt: 0.4, lineHeight: 1.5 }}
          >
            {hint}
          </Typography>
        )}
      </Box>
      <Box sx={{ flexShrink: 0 }}>{control}</Box>
    </Stack>
  );
}
